import { AloftPrice } from '@aloft/toolkit-shared';
import { Button, Flex, Icon, Typography } from '@aloft/toolkit-sui';
import { Badge } from '@aloft/toolkit-sui/chakra';

import { startCase } from 'lodash';

export type PlanCardProps = {
  id: string;
  interval: 'month' | 'year';
  price: AloftPrice;
  features: string[];
  showTrial?: boolean;
  badgeContent?: string;
  badgeColor?: string;
  onPlanSelect: (params: { priceID: string; interval: 'month' | 'year' }) => void;
};

export const PlanCard = ({
  id,
  price,
  interval,
  features,
  badgeContent,
  badgeColor,
  showTrial = false,
  onPlanSelect,
}: PlanCardProps) => (
  <Flex
    flexDirection="column"
    alignItems="center"
    padding="32px"
    gap="16px"
    boxShadow="0px 0px 10px 0px rgba(0,0,0,0.1)"
    backgroundColor="textOffset"
    borderRadius="6px"
    width="320px"
  >
    <Typography variant="h3">{`${startCase(interval)}ly`}</Typography>
    <Flex alignItems="center" gap="4px">
      <Typography variant="h1" __dangerDoNotUseSx={{ fontWeight: 900, fontSize: '2.7rem' }}>
        {price.toString(true)}
      </Typography>
      <Flex flexDirection="column" justifyContent="flex-end">
        {badgeContent && <Badge colorScheme={badgeColor}>17% off</Badge>}
        <Typography variant="h3">/ {interval}</Typography>
      </Flex>
    </Flex>

    <Button
      text={showTrial ? 'Start Free Trial' : 'Get Started'}
      onClick={() => onPlanSelect({ priceID: id, interval })}
    />

    <ul style={{ width: '100%' }}>
      {features.map((feature, index) => (
        <li key={index} style={{ marginTop: '4px' }}>
          <Flex alignItems="center" gap="4px">
            <Icon
              icon="check"
              size="md"
              color="buttonActive"
              __dangerDoNotUseSx={{ flexShrink: 1 }}
            />
            <Typography>{feature}</Typography>
          </Flex>
        </li>
      ))}
    </ul>
  </Flex>
);
